//环信appKey默认配置项
export const DEFAULT_EASEMOB_APPKEY = '1120161224178523#lvyequan-appstore'
export const DEFAULT_EASEMOB_SOCKET_URL = '//im-api-v2.easemob.com/ws'
export const DEFAULT_EASEMOB_REST_URL = '//a1.easemob.com'